import { Stack } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import { css } from '@eti/styles';
import { useCallback, useMemo } from 'react';
import { TripType } from '@eti/schema-types';
import TitledCard from '../../../../common/components/TitledCard';
import { useOrderDetails } from '../../containers/OrderDetailsContext';
import CheckListItems from '../common/CheckListItems';

const stackStyles = css`
  flex: 1;
`;

const BeforeYourTrip = () => {
  const { t } = useTranslation();
  const { journeyType, isVI } = useOrderDetails();

  const getTextFromJourneyType = useCallback(() => {
    switch (journeyType) {
      case TripType.OneWay:
        return 'OrderDetails.TravelInformation.BeforeYourTrip.OneWay';
      case TripType.Return:
        return 'OrderDetails.TravelInformation.BeforeYourTrip.Return';
      default:
        return 'OrderDetails.TravelInformation.BeforeYourTrip.MultiStop';
    }
  }, [journeyType]);

  const listText = useMemo(() => {
    return getTextFromJourneyType();
  }, [getTextFromJourneyType]);

  return (
    <TitledCard
      data-testid="before-your-trip"
      title={t('OrderDetails.TravelInformation.BeforeYourTrip.Header')}
    >
      <Stack className={stackStyles} spacing={8}>
        {isVI && (
          <CheckListItems
            dataTestId="before-your-trip-items"
            htmlTextKey="OrderDetails.TravelInformation.BeforeYourTrip.VI"
          />
        )}
        <CheckListItems dataTestId="before-your-trip-items" htmlTextKey={listText} />
      </Stack>
    </TitledCard>
  );
};

export default BeforeYourTrip;
